import { createGlobalStyle } from 'styled-components';
import bp from './breakpoints';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Rubik', sans-serif;
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
  }

  #root {
    height: 100%;
  }

  a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    outline:0
  }

  button:focus,input:focus,select:focus,textarea:focus {
    outline:0
  }

  article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    display:block
  }

  body { line-height:1 }
  
  ol,ul { list-style:none }

  blockquote,q { quotes:none }

  blockquote:after,blockquote:before,q:after,q:before { content:'';content:none }
  
  table { border-collapse:collapse;border-spacing:0 }
  
  
  a{text-decoration:none}
  
  textarea{resize:none}
  
  .clearfix:after{visibility:hidden;display:block;font-size:0;content:" ";clear:both;height:0}
  
  * html .clearfix{height:1%}
  
  .clearfix{display:block}
  
  * {-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}
  
  body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;text-shadow: 1px 1px 1px rgba(0,0,0,0.004);-webkit-tap-highlight-color: rgba(0,0,0,0);-webkit-text-size-adjust: 100%;}a.active,a.focus,a.visited,a.hover{ text-decoration: none; }
  
  body{
    font-family: 'Roboto';
    font-display:swap!important;
  }   

  /* Stormy: Smooth Trasitions v.:0.1 beta */
  .ts{-webkit-transition:all 300ms ease;-moz-transition:all 300ms ease;-ms-transition:all 300ms ease;-o-transition:all 300ms ease;transition:all 300ms ease}.ts.ts-bg-color{-webkit-transition-property:background-color;-moz-transition-property:background-color;-ms-transition-property:background-color;-o-transition-property:background-color;transition-property:background-color}.ts.ts-color{-webkit-transition-property:color;-moz-transition-property:color;-ms-transition-property:color;-o-transition-property:color;transition-property:color}.ts.ts-opacity{-webkit-transition-property:opacity;-moz-transition-property:opacity;-ms-transition-property:opacity;-o-transition-property:opacity;transition-property:opacity}.ts.ts-border-color{-webkit-transition-property:border-color;-moz-transition-property:border-color;-ms-transition-property:border-color;-o-transition-property:border-color;transition-property:border-color}.ts.ts-width{-webkit-transition-property:width;-moz-transition-property:width;-ms-transition-property:width;-o-transition-property:width;transition-property:width}.ts.ts-height{-webkit-transition-property:height;-moz-transition-property:height;-ms-transition-property:height;-o-transition-property:height;transition-property:height}.ts.ts-linear{-webkit-transition-timing-function:linear;-moz-transition-timing-function:linear;-ms-transition-timing-function:linear;-o-transition-timing-function:linear;transition-timing-function:linear}.ts.ts-ease{-webkit-transition-timing-function:ease;-moz-transition-timing-function:ease;-ms-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease}.ts.ts-ease-in{-webkit-transition-timing-function:ease-in;-moz-transition-timing-function:ease-in;-ms-transition-timing-function:ease-in;-o-transition-timing-function:ease-in;transition-timing-function:ease-in}.ts.ts-ease-out{-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out;-ms-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out}.ts.ts-ease-in-out{-webkit-transition-timing-function:ease-in-out;-moz-transition-timing-function:ease-in-out;-ms-transition-timing-function:ease-in-out;-o-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out}.ts.ts-instant{-webkit-transition-duration:75ms;-moz-transition-duration:75ms;-ms-transition-duration:75ms;-o-transition-duration:75ms;transition-duration:75ms}.ts.ts-quick{-webkit-transition-duration:200ms;-moz-transition-duration:200ms;-ms-transition-duration:200ms;-o-transition-duration:200ms;transition-duration:200ms}.ts.ts-medium{-webkit-transition-duration:300ms;-moz-transition-duration:300ms;-ms-transition-duration:300ms;-o-transition-duration:300ms;transition-duration:300ms}.ts.ts-slow{-webkit-transition-duration:500ms;-moz-transition-duration:500ms;-ms-transition-duration:500ms;-o-transition-duration:500ms;transition-duration:500ms}.ts.ts-slower{-webkit-transition-duration:700ms;-moz-transition-duration:700ms;-ms-transition-duration:700ms;-o-transition-duration:700ms;transition-duration:700ms}.ts.ts-slowest{-webkit-transition-duration:1100ms;-moz-transition-duration:1100ms;-ms-transition-duration:1100ms;-o-transition-duration:1100ms;transition-duration:1100ms}.ts.ts-delay-instant{-webkit-transition-delay:75ms;-moz-transition-delay:75ms;-ms-transition-delay:75ms;-o-transition-delay:75ms;transition-delay:75ms}.ts.ts-delay-quick{-webkit-transition-delay:200ms;-moz-transition-delay:200ms;-ms-transition-delay:200ms;-o-transition-delay:200ms;transition-delay:200ms}.ts.ts-delay-medium{-webkit-transition-delay:300ms;-moz-transition-delay:300ms;-ms-transition-delay:300ms;-o-transition-delay:75ms;transition-delay:300ms}.ts.ts-delay-slow{-webkit-transition-delay:500ms;-moz-transition-delay:500ms;-ms-transition-delay:500ms;-o-transition-delay:75ms;transition-delay:500ms}.ts.ts-delay-slower{-webkit-transition-delay:700ms;-moz-transition-delay:700ms;-ms-transition-delay:700ms;-o-transition-delay:75ms;transition-delay:700ms}.ts.ts-delay-slowest{-webkit-transition-delay:1100ms;-moz-transition-delay:1100ms;-ms-transition-delay:1100ms;-o-transition-delay:1100ms;transition-delay:1100ms}
`;

export const theme = {
  bp,
  colors: {
    primary: {
      main: '#0F3B7A',
      darker: '#003B5C',
      darkest: '#37394c',
    },
    secondary: {
      main: '#89DA3E',
      darker: '#7FCB39',
      light: '#b3fc6f',
    },
    red: '#ED5656',
    cyan: '#009EFF',
    orange: '#f9d066',
    grey: {
      100: '#333333',
      200: '#A6A8A8',
      300: '#D8D9DB',
      400: '#F4F5F5',
      500: '#FDFDFD',
      600: '#BEBDBE',
    },
    white: '#ffffff',
    checkMarkBlue: '#34B7F1',
    outgoingBubble: '#DCF8C6',
    chatBackground: '#ECE5DD',
  },
};
